module.exports = __webpack_public_path__ + "static/media/editDashboard.bb698729.svg";